__turbopack_context__.v({
  "chartWrapper": "parent-module-scss-module__OCykjG__chartWrapper",
  "topIssuersWrapper": "parent-module-scss-module__OCykjG__topIssuersWrapper",
});
